// src/components/shimmerCard/ShimmerCard.tsx
import { forwardRef } from "react";
import { motion } from "framer-motion";
import "./ShimmerCard.scss";

interface ShimmerCardProps {
  number?: string | number;
  icon?: string;
  title?: string;
  description?: string;
  className?: string;
  variant?: "default" | "compact" | "expanded";
  iconBg?: string;
  // Novas props para funcionalidade de sugestão
  text?: string; // Texto da sugestão
  enumValue?: string | number; // Valor enum da sugestão
  onClick?: (text?: string, enumValue?: string | number) => void; // Função de click
  isMobile?: boolean; // Para aplicar estilos mobile
}

const ShimmerCard = forwardRef<HTMLSpanElement, ShimmerCardProps>(
  (
    {
      number,
      icon,
      title,
      description,
      className = "",
      variant = "default",
      iconBg = "bg-transparent",
      // Novas props
      text,
      enumValue,
      onClick,
      isMobile = false,
    },
    ref
  ) => {
    const variantClasses = {
      default: "default",
      compact: "compact",
      expanded: "expanded",
    };

    // Handler para o click - adapta para o formato de sugestão
    const handleClick = () => {
      if (onClick && text) {
        onClick(text, enumValue);
      }
    };

    // Classes condicionais para comportamento de sugestão
    const suggestionClasses = onClick ? "clickable" : "";
    const mobileClasses = isMobile ? "mobile" : "";

    return (
      <span
        ref={ref}
        className={`shimmer-card ${variantClasses[variant]} ${className} ${suggestionClasses} ${mobileClasses}`}
        onClick={handleClick} // Adiciona funcionalidade de click
      >
        {/* Ícone/Número - só renderiza se existir */}
        {(number || icon) && (
          <span className={`icon-container ${iconBg && iconBg}`}>
            {number} {icon && <img src={icon} alt={title} />}
          </span>
        )}

        {/* Título - renderiza title ou text */}
        {(title || text) && <h3 className="title">{title || text}</h3>}

        {/* Descrição */}
        {description && <p className="description">{description}</p>}
      </span>
    );
  }
);

ShimmerCard.displayName = "ShimmerCard";

// Cria o motion component
export const MotionShimmerCard = motion(ShimmerCard);
export default ShimmerCard;
